<template>
  <section class="main-content">
    <MainBanner banner="Wir.Partner" />
    <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Startseite - ito consult GmbH",
        "item": "https://ito-consult.de"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Über uns",
        "item": "https://ito-consult.de/wir"
      },{
        "@type": "ListItem",
        "position": 3,
        "name": "Partner",
        "item": "https://ito-consult.de/wir/partner"
      }]
    }
  </script>
    <section class="block-content py-5 mb-5 bg-grey">
        <div class="container my-md-5 py-md-5">
            <div class="content-midwide text-md-center" data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100">
                <article v-html="partner_content"></article>
            </div>
        </div>
    </section>
    <section class="block-content mb-5">
        <div class="container my-md-5 py-md-5">
            <div v-for="partner in partner" :key="partner.id" class="content-midwide partner-item my-4" data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100">
                <span class="py-3">
                    <h3 class="text-start">
                        <img v-if="partner.logo" class="partner_logo" :src="partner.logo.data.full_url"  :title="partner.title"/>
                        <span v-else>{{partner.title}}</span>
                    </h3>
                    <div class="row justify-content-center">
                        <div class="col">
                            <article class="d-content" v-html="partner.description"></article>
                        </div>
                        <div class="col-12 col-md-5 col-lg-4 col-xl-3 text-md-end">
                            <router-link :title="'Weitere Informationen zu' + partner.title" v-if="partner.full_description" :to="{name: 'ito.partner.single', params: {id: partner.slug}}" class="btn btn-outline-ito hover-red mb-4 animated-arrow">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
                                </svg>
                                mehr erfahren
                            </router-link>
                            <a title="Gehe zur Partnerwebsite" :href="partner.url" target="_blank" class="btn btn-outline-ito hover-red animated-arrow">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
                                </svg>
                                Website des Partners
                            </a>
                        </div>
                    </div>
                </span>
                <hr>
            </div>

        </div>
    </section>
  </section>
</template>

<script>

import axios from 'axios'
import store from '@/store'
const MainBanner = () => import('@/components/Content/MainBanner.vue')

export default {
  name: 'Partner',
  metaInfo () {
    return {
      title: this.$parent.getMetaTitle('Wir.Partner'),
      meta: [
        { name: 'description', content: this.$parent.getDescription('Wir.Partner') },
        { property: 'og:title', content: this.$parent.getOGTitle('Wir.Partner') },
        { property: 'og:description', content: this.$parent.getOGDescription('Wir.Partner') }
      ]
    }
  },
  data: function () {
    return {
      partner: {}
    }
  },

  async beforeMount () {
    await axios.get('/business_partner?fields=*.*')
      .then(response => {
        this.partner = response.data.data
        store.commit('loadingStatus', false)
      })
  },
  components: {
    MainBanner
  },
  computed: {
    partner_content () {
      if (typeof this.$store.getters.content.data !== 'undefined') {
        const txt = this.$store.getters.content.data.filter(item => {
          return item.title.indexOf('Partner') > -1
        })
        return txt.length ? txt[0].content : ''
      } else {
        return ''
      }
    }
  }
}
</script>
<style scoped>
    .partner_logo {max-width: 200px;}
    .text_start {text-align: left !important;}
</style>
